import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type TelegramProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function TelegramPage({ children, ...props }: TelegramProps) {
  return (
    <MarkdownPage group={"public"} message={"telegram"}></MarkdownPage>
  )
}
